<template>
  <div>
    <div v-if="openPopup" class="popup-container">
      <div @click="togglePopup" class="overlay"></div>
      <div class="modal-custom-container">
      <nuxt-link :to="goPage()" @click="togglePopup">
        <div class="item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="66"
            viewBox="0 0 66 66"
            fill="none"
          >
            <rect
              x="0.5"
              y="0.5"
              width="64.8"
              height="64.8"
              rx="32.4"
              fill="white"
            />
            <rect
              x="0.5"
              y="0.5"
              width="64.8"
              height="64.8"
              rx="32.4"
              stroke="#DFE3EA"
            />
            <path
              d="M36.2601 32.3262C36.2601 31.7546 36.2389 31.2254 36.2601 30.6963C36.3236 28.9817 37.7206 27.6905 39.4141 27.754C40.9805 27.7963 42.2928 29.1087 42.3352 30.6963C42.3564 31.2466 42.3352 31.7758 42.3352 32.3262C42.695 32.3473 43.0337 32.3473 43.3512 32.4108C44.5154 32.6225 45.3198 33.7021 45.2352 34.8663C45.0023 37.7874 44.7483 40.6874 44.5154 43.6085C44.4096 44.7939 43.4571 45.7253 42.2717 45.7464C40.2819 45.7676 38.271 45.7676 36.2812 45.7464C35.117 45.7253 34.1645 44.8151 34.0586 43.6297C33.8046 40.7509 33.5718 37.8509 33.3389 34.9721C33.2119 33.5115 34.2703 32.3685 35.7309 32.3685C35.9214 32.3262 36.0696 32.3262 36.2601 32.3262ZM40.5148 32.3262C40.5148 31.7546 40.5359 31.2043 40.5148 30.6539C40.4724 30.0824 39.9856 29.6379 39.4141 29.5955C38.8214 29.5532 38.2287 29.9131 38.1652 30.4846C38.0805 31.0984 38.144 31.7123 38.144 32.3262C38.9272 32.3262 39.7104 32.3262 40.5148 32.3262Z"
              fill="#A7B9D0"
            />
            <path
              d="M33.571 31.0554C32.6396 31.6269 32.0258 32.4102 31.7083 33.405C31.4542 34.1882 31.5389 34.9926 31.6024 35.797C31.7718 37.7656 31.9411 39.7342 32.0893 41.7027C32.1528 42.5494 32.2375 43.375 32.301 44.2429C32.1951 44.2429 32.0893 44.2429 32.0046 44.2429C28.9776 44.2429 25.9507 44.2429 22.9237 44.2429C21.1668 44.2429 20.0237 43.0786 20.0026 41.3429C19.9814 39.2261 20.0872 37.1094 20.4683 35.0349C20.7858 33.2992 21.7806 31.9445 23.2624 30.9708C23.6646 30.7167 24.0456 30.8014 24.4054 31.0554C25.6543 31.9233 27.0302 32.3466 28.5543 32.3043C29.9513 32.262 31.2214 31.8386 32.3645 31.0343C32.7878 30.7591 33.1053 30.7591 33.571 31.0554Z"
              fill="#A7B9D0"
            />
            <path
              d="M28.3635 21C30.7978 21 32.7663 22.9686 32.7663 25.3817C32.7663 27.816 30.7978 29.8057 28.3635 29.8057C25.9292 29.8057 23.9394 27.816 23.9606 25.3817C23.9606 22.9474 25.9504 21 28.3635 21Z"
              fill="#A7B9D0"
            />
          </svg>
          <h5>{{ $t('indi') }}</h5>
          <p> {{ $t('modelP') }} </p>
        </div>
      </nuxt-link>
      <nuxt-link :to="localePath('/order-company')" @click="togglePopup">
        <div class="item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="66"
            viewBox="0 0 66 66"
            fill="none"
          >
            <rect
              x="0.5"
              y="0.5"
              width="64.8"
              height="64.8"
              rx="32.4"
              stroke="#DFE3EA"
            />
            <path
              d="M23.454 45.5665C23.454 45.3824 23.454 45.2188 23.454 45.0757C23.454 37.3251 23.454 29.5951 23.454 21.8446C23.454 20.0041 24.5583 18.5521 26.2556 18.1227C26.5828 18.0409 26.9305 18 27.2781 18C31.2659 18 35.2331 18 39.2209 18C41.4499 18 43.045 19.5951 43.045 21.8446C43.045 29.5951 43.045 37.3251 43.045 45.0757C43.045 45.2188 43.045 45.3824 43.045 45.5665C43.3926 45.5665 43.6994 45.5665 44.0266 45.5665C44.9468 45.5665 45.499 46.0368 45.499 46.7935C45.499 47.5296 44.9264 48 44.047 48C37.9121 48 31.7771 48 25.6421 48C24.5378 48 23.454 48 22.3497 48C21.5726 48 21.0204 47.4887 21 46.7935C21 46.0777 21.5521 45.5665 22.3497 45.5665C22.6973 45.546 23.045 45.5665 23.454 45.5665ZM35.7035 45.771C35.7035 44.3599 35.7239 42.9693 35.7035 41.5992C35.683 40.7607 34.9059 40.0654 34.047 40.045C33.5562 40.045 33.045 40.045 32.5542 40.045C31.5521 40.045 30.8159 40.7812 30.8159 41.7832C30.8159 42.7853 30.8159 43.7669 30.8159 44.7689C30.8159 45.0961 30.8159 45.4233 30.8159 45.771C32.4519 45.771 34.047 45.771 35.7035 45.771ZM29.5481 25.3415C29.7935 25.3415 30.0389 25.362 30.2843 25.3415C30.9182 25.3006 31.4294 24.7689 31.4294 24.135C31.4294 23.501 30.9387 22.9489 30.2843 22.908C29.8344 22.8875 29.364 22.8875 28.9141 22.908C28.2597 22.9284 27.7689 23.4601 27.7485 24.0941C27.728 24.7485 28.2393 25.3006 28.8937 25.3415C29.1186 25.362 29.3231 25.3415 29.5481 25.3415ZM36.9305 25.3415C37.1554 25.3415 37.3804 25.362 37.6258 25.3415C38.2597 25.3006 38.771 24.7485 38.771 24.1145C38.771 23.4806 38.2802 22.9284 37.6258 22.908C37.1759 22.8875 36.7055 22.8875 36.2556 22.908C35.6012 22.9284 35.1104 23.4601 35.1104 24.1145C35.1104 24.7689 35.6012 25.3211 36.2761 25.362C36.4806 25.362 36.7055 25.3415 36.9305 25.3415ZM29.5481 30.863C29.7935 30.863 30.0389 30.8834 30.2843 30.863C30.9182 30.8221 31.4294 30.2699 31.4294 29.636C31.4294 29.002 30.9387 28.4499 30.2843 28.4294C29.8344 28.409 29.364 28.409 28.9141 28.4294C28.2597 28.4499 27.7689 28.9816 27.7485 29.636C27.7485 30.2904 28.2393 30.8425 28.9141 30.8834C29.1186 30.863 29.3231 30.863 29.5481 30.863ZM36.9305 30.863C37.1554 30.863 37.3804 30.8834 37.6258 30.863C38.2597 30.8221 38.771 30.2904 38.771 29.6564C38.771 29.002 38.2597 28.4499 37.6053 28.4294C37.1554 28.409 36.7055 28.409 36.2761 28.4294C35.6217 28.4499 35.1104 29.002 35.1104 29.6564C35.1104 30.2904 35.6217 30.8221 36.2556 30.863C36.4601 30.863 36.7055 30.863 36.9305 30.863ZM29.5481 36.364C29.7935 36.364 30.0389 36.3845 30.2843 36.364C30.9182 36.3231 31.4294 35.771 31.4294 35.137C31.4294 34.5031 30.9387 33.9509 30.2843 33.9305C29.8344 33.91 29.364 33.91 28.9141 33.9305C28.2597 33.9509 27.7689 34.4826 27.7485 35.137C27.7485 35.7914 28.2393 36.3435 28.9141 36.3844C29.1186 36.3844 29.3231 36.364 29.5481 36.364ZM36.9305 36.364C37.1554 36.364 37.3599 36.364 37.5849 36.364C38.2393 36.3231 38.771 35.7914 38.771 35.137C38.771 34.4826 38.2597 33.9305 37.6053 33.91C37.1554 33.8896 36.7055 33.8896 36.2761 33.91C35.6217 33.9305 35.1309 34.4622 35.1104 35.0961C35.09 35.7505 35.6012 36.3027 36.2556 36.3436C36.4806 36.3845 36.7055 36.364 36.9305 36.364Z"
              fill="#A7B9D0"
            />
          </svg>
          <h5>{{ $t('comp') }}</h5>
          <p> {{ $t('modelP') }} </p>
        </div>
      </nuxt-link>
        <button @click="togglePopup" class="close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L8 6.58579L13.2929 1.29289C13.6834 0.902369 14.3166 0.902369 14.7071 1.29289C15.0976 1.68342 15.0976 2.31658 14.7071 2.70711L9.41421 8L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L8 9.41421L2.70711 14.7071C2.31658 15.0976 1.68342 15.0976 1.29289 14.7071C0.902369 14.3166 0.902369 13.6834 1.29289 13.2929L6.58579 8L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289Z"
              fill="#A7B9D0"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
let props = defineProps(["openPopup" , "id" , "nameCar"]);
const emit = defineEmits(["update"]);
const localePath = useLocalePath();

const goPage = () =>{
  if(props.id){
    return localePath({ path: '/order-individuals', query:{id: props.id , name: props.nameCar} });
  } else{
    return localePath('/order-individuals');
  }
}

const togglePopup = () => {
  emit("update", !props.openPopup);
};
</script>
